export default {
    products: [],
    product: null,
    labels: {},
    status: null,
}